import type { ComponentPropsWithoutRef } from "react";

import { tw } from "@/shared/utils";

interface MessageProps extends ComponentPropsWithoutRef<"p"> {
  message?: string;
  error?: string | boolean;
}

export const Message = ({ message, error, className }: MessageProps) => (
  <p
    className={tw(
      "block text-left text-sm text-neutral-700",
      className,

      !!error && "text-red-700",
    )}
  >
    {error === true ? "\u200b" : (error ?? message ?? "\u200b")}
  </p>
);
